import React, { useContext } from "react";

import { storageHelper } from "lib/helpers";
import { SkeletonAnnotated } from "lib/components";
import { PrivateContext } from "lib/context";

import constant from "lib/constant/constant";
// import { AdminProductEdit } from "./admin/features";
import OperatorProductEdit from "./operator/features/editService/edit";
import { ProviderProductServiceEdit } from "./provider/features";

const { userKey } = constant;
const { operator, provider } = userKey;

const ProductServiceEdit = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (role === operator) {
      return <OperatorProductEdit />;
    }
    if (role === provider) {
      return <ProviderProductServiceEdit />;
    }
    return null;
  };
  if (isLoading) {
    return <SkeletonAnnotated />;
  }

  const currentUserRole = storageHelper.get("userRole");
  const ProductEditComponent = getComponent(currentUserRole);
  return ProductEditComponent;
};

export default ProductServiceEdit;
